import { ChevronRight } from '@fagmobler/ui';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

type SectionContainerButtonProps = {
  title: string;
  Icon?: any;
  className?: string;
  onClick?: () => void;
};

export default function SectionContainerButton({
  title,
  Icon,
  className,
  onClick,
}: SectionContainerButtonProps) {
  return (
    <button
      onClick={onClick}
      className={twMerge(
        clsx('flex items-center justify-center gap-2 py-2 group', className)
      )}
    >
      {Icon && <Icon className="w-5 h-5" />}
      <span className="flex-grow text-left body-sm group-hover:underline">
        {title}
      </span>
      <ChevronRight className="w-4 h-4" />
    </button>
  );
}
